import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-14c4c2f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "email-campaign-card" };
const _hoisted_2 = { class: "email-campaign-card__header" };
const _hoisted_3 = { class: "header-top" };
const _hoisted_4 = { class: "email-campaign-card__header-title" };
const _hoisted_5 = { class: "email-campaign-card__title" };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = { class: "email-balance" };
const _hoisted_8 = ["innerHTML"];
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import CampaignsDynamicTable from '@/features/CampaignsEmail/components/CampaignsDynamicTable.vue';
import TemplatePreviewDialog from '@/features/CampaignsEmail/components/TemplatePreviewDialog.vue';
import ConfirmFinishDialog from '@/features/CampaignsEmail/components/ConfirmFinishDialog.vue';
import ConfirmDeleteDialog from '@/features/CampaignsEmail/components/ConfirmDeleteDialog.vue';
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
import { useEmailBalance } from '@/features/CampaignsEmail/composables/useEmailBalance';
import { useCampaignsTable } from '@/features/CampaignsEmail/composables/useCampaignsTable';
import { useEmailCampaignListRefresh } from '@/features/CampaignsEmail/composables/useEmailCampaignListSync';
import { deleteCampaign, finishCampaign } from '@/features/CampaignsEmail/services/actions';
import { getCampaignDetails } from '@/features/CampaignsEmail/services/getCampaignDetails';
import { getRowId } from '@/features/CampaignsEmail/services/utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignEmail',
    setup(__props) {
        const toast = useToast();
        const { t } = useI18n();
        const router = useRouter();
        const { loading, state, setPage, setSort, setFilters, reload } = useCampaignsTable();
        const { emailBalance, emailBalanceResetDate, lastBalanceUpdate, loading: balanceLoading } = useEmailBalance();
        const showToast = {
            success: (message) => toast.success(message, { timeout: 3000 }),
            error: (message) => toast.error(message, { timeout: 4000 }),
        };
        const previewOpen = ref(false);
        const currentPreview = ref(null);
        const finishOpen = ref(false);
        const finishing = ref(false);
        const campaignToFinish = ref(null);
        const deleteOpen = ref(false);
        const deleting = ref(false);
        const campaignToDelete = ref(null);
        const currentStatus = ref('');
        async function openPreview(row) {
            const id = getRowId(row);
            if (!id) {
                showToast.error(t('breadcrumb.email.campaigns.toasts.id-error'));
                return;
            }
            try {
                const details = await getCampaignDetails(id);
                const assunto = details.subject ||
                    details.title ||
                    row.subject ||
                    row.assunto ||
                    '';
                const precabecalho = details.preheader ||
                    details.preheader_text ||
                    row.preheader ||
                    row.precabecalho ||
                    '';
                currentPreview.value = {
                    assunto: String(assunto),
                    precabecalho: String(precabecalho),
                    html: String(details.template ?? row.html ?? row.bodyHtml ?? ''),
                    texto: String(details.text ?? row.text ?? row.texto ?? ''),
                };
                const rawStatus = details.status?.name ?? row.status ?? '';
                currentStatus.value = String(rawStatus);
                previewOpen.value = true;
            }
            catch (e) {
                console.error(e);
                showToast.error(t('breadcrumb.email.campaigns.toasts.preview-error'));
            }
        }
        function goCreate() {
            router.push({ name: 'email.campaign-create' });
        }
        useEmailCampaignListRefresh({ state, setPage, reload });
        async function handlePageChange({ page, limit }) {
            await setPage(page, limit);
        }
        function handleSortChange(orderBy) {
            setSort(orderBy);
        }
        function handleFiltersChanged(filters) {
            setFilters(filters || {});
        }
        function handleEdit(row) {
            const id = getRowId(row);
            if (!id)
                return showToast.error(t('breadcrumb.email.campaigns.toasts.id-error'));
            router.push(`/email/email-campaign-list/edit/${id}`);
        }
        function handleDelete(row) {
            campaignToDelete.value = row;
            deleteOpen.value = true;
        }
        async function confirmDelete() {
            if (!campaignToDelete.value)
                return;
            const id = getRowId(campaignToDelete.value);
            if (!id)
                return showToast.error(t('breadcrumb.email.campaigns.toasts.id-error'));
            try {
                deleting.value = true;
                await deleteCampaign(id);
                showToast.success(t('breadcrumb.email.campaigns.toasts.delete-success'));
                deleteOpen.value = false;
                campaignToDelete.value = null;
                reload();
            }
            catch (e) {
                console.error(e);
                showToast.error(t('breadcrumb.email.campaigns.toasts.delete-error'));
            }
            finally {
                deleting.value = false;
            }
        }
        function cancelDelete() {
            deleteOpen.value = false;
            campaignToDelete.value = null;
        }
        function handleFinish(row) {
            campaignToFinish.value = row;
            finishOpen.value = true;
        }
        async function confirmFinish() {
            if (!campaignToFinish.value)
                return;
            const id = getRowId(campaignToFinish.value);
            if (!id)
                return showToast.error(t('breadcrumb.email.campaigns.toasts.id-error'));
            try {
                finishing.value = true;
                await finishCampaign(id);
                finishOpen.value = false;
                campaignToFinish.value = null;
                showToast.success(t('breadcrumb.email.campaigns.toasts.finish-success'));
                reload();
            }
            catch (e) {
                console.error(e);
                showToast.error(t('breadcrumb.email.campaigns.toasts.finish-error'));
            }
            finally {
                finishing.value = false;
            }
        }
        function cancelFinish() {
            finishOpen.value = false;
            campaignToFinish.value = null;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('breadcrumb.email.email-campaign-list')), 1),
                                (_unref(lastBalanceUpdate) && !_unref(balanceLoading))
                                    ? (_openBlock(), _createElementBlock("p", {
                                        key: 0,
                                        class: "last-updated",
                                        innerHTML: _ctx.$t('breadcrumb.email.campaign.last-balance-update', {
                                            datetime: _unref(lastBalanceUpdate),
                                        })
                                    }, null, 8, _hoisted_6))
                                    : _createCommentVNode("", true),
                                (_unref(balanceLoading))
                                    ? (_openBlock(), _createBlock(SkeletonLoader, {
                                        key: 1,
                                        width: "280px",
                                        height: "12px",
                                        class: "last-updated-skeleton"
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                    class: "btn campaign-create-btn",
                                    onClick: goCreate
                                }, _toDisplayString(_ctx.$t('campaigns.create-campaign')), 1)
                            ])
                        ]),
                        _createElementVNode("p", _hoisted_7, [
                            (_unref(emailBalance) && _unref(emailBalanceResetDate) && !_unref(balanceLoading))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "text-left",
                                    innerHTML: _ctx.$t('breadcrumb.email.campaign.email-balance', {
                                        email_balance: _unref(emailBalance),
                                        email_balance_reset_date: _unref(emailBalanceResetDate),
                                    })
                                }, null, 8, _hoisted_8))
                                : _createCommentVNode("", true),
                            (_unref(balanceLoading))
                                ? (_openBlock(), _createBlock(SkeletonLoader, {
                                    key: 1,
                                    width: "380px",
                                    height: "14px"
                                }))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createVNode(CampaignsDynamicTable, {
                        columns: _unref(state).columns,
                        rows: _unref(state).rows,
                        loading: _unref(loading),
                        page: _unref(state).pagination.page,
                        limit: _unref(state).pagination.limit,
                        total: _unref(state).pagination.count,
                        "order-by": _unref(state).sort.orderBy,
                        onChangePage: handlePageChange,
                        onFiltersChanged: handleFiltersChanged,
                        onSortChange: handleSortChange,
                        onPreview: openPreview,
                        onEdit: handleEdit,
                        onDelete: handleDelete,
                        onFinish: handleFinish
                    }, null, 8, ["columns", "rows", "loading", "page", "limit", "total", "order-by"])
                ]),
                _createVNode(TemplatePreviewDialog, {
                    modelValue: previewOpen.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((previewOpen).value = $event)),
                    template: currentPreview.value,
                    status: currentStatus.value
                }, null, 8, ["modelValue", "template", "status"]),
                _createVNode(ConfirmFinishDialog, {
                    modelValue: finishOpen.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((finishOpen).value = $event)),
                    "campaign-name": String(campaignToFinish.value?.name ?? campaignToFinish.value?.campaign_name ?? '—'),
                    "is-recurrent": Boolean(campaignToFinish.value?.is_recurrent),
                    loading: finishing.value,
                    onConfirm: confirmFinish,
                    onCancel: cancelFinish
                }, null, 8, ["modelValue", "campaign-name", "is-recurrent", "loading"]),
                _createVNode(ConfirmDeleteDialog, {
                    modelValue: deleteOpen.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((deleteOpen).value = $event)),
                    "campaign-name": String(campaignToDelete.value?.name ?? campaignToDelete.value?.campaign_name ?? '—'),
                    loading: deleting.value,
                    onConfirm: confirmDelete,
                    onCancel: cancelDelete
                }, null, 8, ["modelValue", "campaign-name", "loading"])
            ], 64));
        };
    }
});
